import React, { useRef, forwardRef, useImperativeHandle } from "react";
import { useQuery } from "@tanstack/react-query";
import InputWithChecks from "../../shared/InputWithChecks";
import { fetchCollections } from "../../../util/admin/httpAdmin";

const CollectionDropdown = forwardRef(({ value, onChange, validate }, ref) => {
   const existingCollectionRef = useRef(null);

   // Fetch collections met React Query
   const {
      data: collections = [],
      isLoading,
      isError,
      error,
   } = useQuery({
      queryKey: ["adminCollections"],
      queryFn: ({ signal }) => fetchCollections({ signal }),
   });

   // Expose the current value to the parent via ref
   useImperativeHandle(ref, () => ({
      getValue: () => existingCollectionRef.current?.getValue(),
      validateInput: () => existingCollectionRef.current?.validateInput(),
   }));

   if (isLoading) {
      return <p>Collecties laden...</p>;
   }

   if (isError) {
      return <p>Fout bij laden van collecties: {error.message}</p>;
   }

   return (
      <div className="collection-dropdown">
         <InputWithChecks
            ref={existingCollectionRef}
            label="Collectie"
            inputType="select"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            validate={validate}
         >
            <option value="">Geen Collectie</option>
            {collections.map((collection) => (
               <option key={collection._id} value={collection._id}>
                  {collection.name}
               </option>
            ))}
         </InputWithChecks>
      </div>
   );
});

export default CollectionDropdown;